jQuery.feature_import("js-populate-origin",
  () => require("./populate.js"),
  mod => mod.feature_js_populate_origin
);

jQuery.feature_import("js-populate-transport-tags",
    () => require("./populate.js"),
    mod => mod.feature_js_populate_transport_tags
);